import { useLocalStorage } from 'usehooks-ts'

export default useLocalStorage
